<template>
  <div class="content">
    <!-- 上白板step -->
    <div class="nav-border">
      <span class="nav-lspan">客户名称：<span style="color: green;">{{ this.$route.query.name }}</span></span>
      <!-- 按钮 -->
      <div class="nav_but">
        <a-button class="bottom-button" type="primary" ghost @click="cancle" >返回</a-button>
      </div>
    </div>

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid.field"
          :data-source="relevanceBatch_grid.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
          :pagination="false"
          :loading="tableLoading"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{index + 1}}
          </span>
          <!-- 服务状态 -->
          <span slot="recStatus" slot-scope="text, record, index">
            <span v-if="record.recStatus == '1'"><a-badge color="gold" /></span>
            <span v-else-if="record.recStatus == '4'"><a-badge color="red"/></span>
            <span v-else-if="record.recStatus == '2' || record.recStatus == '3'"><a-badge color="cyan"/></span>
            {{ record.recStatus | DictionaryFilter("REC_STATUS") }}
          </span>
        </a-table>

        <!-- 底部 -->
        <div class="table_bottom">
    
          <!-- 分页 -->
          <div>
            <a-pagination
              class="table_pagination"
              show-size-changer
              :default-current="1"
              v-model="pageParam.pageNum"
              :show-total="(total) => `共 ${total} 条`"
              :page-size-options="pageSizeOptions"
              size="small"
              :total="total"
              @showSizeChange="onShowSizeChange"
              @change="paginationChange"
              :page-size.sync="pageParam.pageSize"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import {
  queryFamilyById,
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  components: {
  },
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    return {
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 40,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "项目名称",
            align: "center",
            width: 100,
            dataIndex: "prName",
            ellipsis: true,
          },
          {
            title: "申请数量",
            align: "center",
            width: 50,
            dataIndex: "count",
            ellipsis: true,
          },
          {
            title: "申请时间",
            align: "center",
            width: 100,
            dataIndex: "createTime",
            ellipsis: true,
          },
          {
            title: "服务编号",
            colSpan: 1,
            width: 100,
            dataIndex: "recNo",
            align: "center",
            ellipsis: true,
          },
          {
            title: "服务状态",
            colSpan: 1,
            align: "center",
            width: 60,
            ellipsis: true,
            dataIndex: "recStatus",
            scopedSlots: {
              customRender: "recStatus",
            },
          },
          {
            title: "服务地点",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "networkName",
          },
          {
            title: "联系方式",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "phoneNo",
          },
          {
            title: "客户备注",
            colSpan: 1,
            align: "center",
            width: 100,
            ellipsis: true,
            dataIndex: "custRemark",
          },
        ]
      },

      //响应数据
      resDate: {},
      tableLoading: false,

      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,


    };
  },
  mounted() {
  // 获取字典
  DictionaryService.getAllNeedDic(["REC_STATUS"]).then((res) => {
      //查询
      this.queryList();
  }); 
  this.relevanceBatch_grid.width = 0;
  this.relevanceBatch_grid.field.map(item => {
    this.relevanceBatch_grid.width += item.width;
  });
  },
  methods: {
    //查询接口
    queryList() {
      let paramsObj = {
        id : this.$route.query.id
      }
      queryFamilyById(
        {
          pageParam: {
            pageNum: this.pageParam.pageNum,
            pageSize: this.pageParam.pageSize,
            orderBy: ""
          },
          content: paramsObj
        })
      .then(res => {
          if (res.content.rows && res.content.rows.length) {
            this.relevanceBatch_grid.row = res.content.rows;
            this.total = res.content.page.totalRows;
          } else {
            this.relevanceBatch_grid.row = [];
            this.total = 0;
          }
          this.tableLoading = false;
        }, (err) => {
          this.tableLoading = false;
        });
    },
    // 取消按钮
    cancle() {
      this.$router.go(-1);
    },

    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
  },
};
</script>
    
<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    width: 100%;
    height: 60px;
    background: #fff;
    z-index: 100;
    display: flex;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 2px;
    .nav-lspan {
      margin-left: 100px;
      font-size: 16px;
      float: left;
      margin: 8px 8px 8px 30px;
      color: black;
      flex: 1;
    }
    .nav_but{
      margin-right: 30px;
    }
  }
  .body {
    display: flex;
    justify-content: space-between;
    height: 88%;
    background: #fff;
    .body-content {
      padding: 15px 0px 15px 0px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one{
        height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-upload-list {
  display: none;
}

.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }
  .itemname {
  }
  .itemsta {
    float: right;
    margin-right: 30%;
  }
  .download {
    float: right;
    margin: 5px;
  }
  .del {
    float: right;
    margin: 5px;
  }
}
.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
}

.table_bottom{
  
  .bottom_btn{
    margin-top: 10px;

    .btn_first{
      margin-right: 10px;
    }
  }
}
/deep/ .ant-pagination{
  padding-top: 20px;
  text-align: right;
}
</style>